var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppIcon = function SvgAppIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.472,13.252c-1.926,1.962-5.079,1.995-7.045,0.076c-1.97-1.923-2.006-5.078-0.085-7.048l-2.107-2.063    c0,0-0.002,0.004-0.004,0.007l-4.28-4.182L0.139,28.502l4.266,4.168l2.156,2.105c1.906-1.948,5.034-1.986,6.986-0.082    c1.952,1.908,1.986,5.034,0.079,6.987l2.156,2.109l4.267,4.168l27.812-28.462L41.472,13.252z M33.876,28.112L19.981,42.335    l-2.212-2.16c0.67-2.658-0.019-5.581-2.122-7.632c-2.099-2.052-5.035-2.673-7.678-1.944l-2.212-2.162l13.896-14.219l2.843,2.779    l2.084-2.133l-2.844-2.779l6.254-6.4l2.232,2.184c-0.656,2.644,0.038,5.547,2.122,7.591c2.093,2.046,5.018,2.676,7.652,1.959    l2.214,2.161l-6.253,6.398l-2.728-2.665l-2.086,2.136L33.876,28.112z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#241F20",
    height: 2.984,
    transform: "matrix(-0.7153 -0.6988 0.6988 -0.7153 33.6482 53.9094)",
    width: 6.006,
    x: 24.803,
    y: 18.608
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app-icon.42470269.svg";
export { ForwardRef as ReactComponent };